export const routeHasResources = route => !!(route && route.resources && route.resources.length > 0);
export const routeHasChanged = (prev, next) => prev.name !== next.name || prev.path !== next.path;